'use client';

import { createContext, useContext, type PropsWithChildren } from 'react';
import { usePrivate } from '@/components/private/PrivateContext';
import { usePublicSearchSyncNotifications } from '@/hooks/usePublicSearchSyncNotifications';

type PublicSearchSyncNotificationsContextValue = {
  notifyQueued: (syncMessageId?: string | null) => void;
};

const PublicSearchSyncNotificationsContext =
  createContext<PublicSearchSyncNotificationsContextValue | null>(null);

export function PublicSearchSyncNotificationsProvider({
  children,
}: PropsWithChildren) {
  const { userGuid } = usePrivate();
  const { notifyQueued } = usePublicSearchSyncNotifications(userGuid);

  return (
    <PublicSearchSyncNotificationsContext.Provider value={{ notifyQueued }}>
      {children}
    </PublicSearchSyncNotificationsContext.Provider>
  );
}

export function useNotifyPublicSearchSync() {
  const context = useContext(PublicSearchSyncNotificationsContext);
  return context?.notifyQueued ?? (() => {});
}
